
    <h1>Mot de passe perdu</h1>
    <spaq-forgot-password
      (onSubmit)="submit($event)"
      [error]="error$ | async"
      [pending]="pending$ | async"
      [formData]="form$ | async">
    </spaq-forgot-password>
  


// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/auth/forgot-password/containers/forgot-password-page.component.ts.ForgotPasswordPageComponent.html